'use client';

import { FoodDetailComponent } from 'components/glucose-db/FoodDetailComponent';
import { FoodOptimizationSection } from 'components/glucose-db/FoodOptimizationSection';
import { HealthSpanSection } from 'components/ring-air-landing';
import type {
  FoodDetailDataType,
  FoodSummary,
  MealOptimisation,
} from 'lib/ogdb/types';
import { CustomImage as Image } from 'components/shared';
import { useRegionLocale } from 'contexts/RegionLocaleContext';
import styles from './food-client.module.css';

function BGgradImage({ src }: { src: string }) {
  return (
    <Image
      width={1000}
      height={1000}
      className={styles.bgGradImage}
      alt=""
      src={src}
    />
  );
}

export default function GlucoseResponseDB(props: {
  data: FoodDetailDataType;
  optimization: MealOptimisation | null;
  suggestions: FoodSummary[];
}) {
  // The US sells M2 Live, not M1 (docs/m2-us-branding-migration-plan.md).
  const { region } = useRegionLocale();
  const cgm = region === 'US' ? 'M2' : 'M1';

  return (
    <main
      style={{
        backgroundColor: '#000000',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <BGgradImage
        src={
          props.data.average_score > 7
            ? 'web_v2/grdb/images/green-blur-ball.png'
            : props.data.average_score > 5
            ? 'web_v2/grdb/images/yellow-blur-ball.png'
            : 'web_v2/grdb/images/red-blur-ball.png'
        }
      />
      <FoodDetailComponent data={props.data} suggestions={props.suggestions} />
      <FoodOptimizationSection data={props.optimization} />
      <HealthSpanSection
        imageMobile="landing/bg/m1_bg_responsive_tinted.png"
        title={
          <>
            Discover <br /> metabolic <br />
            health with {cgm}
          </>
        }
        titleLarge
        description={`Ultrahuman ${cgm} helps you measure the impact of food and activity on your body in real time through glucose as a biomarker.`}
        btnText={<>Explore Ultrahuman {cgm}</>}
        textColor="white"
        ctaLink="/pricing"
        analyticEvent="ogdb-food-detail-m1-cta-clicked"
      />
    </main>
  );
}
